import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { SelectModule } from '../select/select.module';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LcsSingleSelectPanelDirective } from './single-select-panel.directive';
import { LcsSingleSelectWrapperComponent } from './single-select-wrapper/single-select-wrapper.component';
import {
   LCS_SINGLE_SELECT_SCROLL_STRATEGY_FACTORY_PROVIDER,
   LcsSingleSelectDirective,
} from './single-select.directive';
import { LcsStaticSingleSelectInputDirective } from './static/static-select-input.directive';
import { LcsStaticSingleSelectComponent } from './static/static-select.component';

@NgModule({
   declarations: [
      LcsSingleSelectDirective,
      LcsSingleSelectPanelDirective,
      LcsStaticSingleSelectInputDirective,
      LcsStaticSingleSelectComponent,
      LcsSingleSelectWrapperComponent,
   ],
   exports: [
      LcsSingleSelectDirective,
      LcsSingleSelectPanelDirective,
      LcsStaticSingleSelectInputDirective,
      LcsStaticSingleSelectComponent,
      SelectModule,
      LcsSingleSelectWrapperComponent,
   ],
   imports: [
      CommonModule,
      LcsLoadingOverlayModule,
      MatProgressSpinnerModule,
      OverlayModule,
      PortalModule,
      ReactiveFormsModule,
      SelectModule,
   ],
   providers: [LCS_SINGLE_SELECT_SCROLL_STRATEGY_FACTORY_PROVIDER],
})
export class LcsSingleSelectModule {}
